import { render, staticRenderFns } from "./TaskAssignedNotification.vue?vue&type=template&id=67cef5ff"
import script from "./TaskAssignedNotification.vue?vue&type=script&lang=js"
export * from "./TaskAssignedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports